import * as yup from "yup";

export const schema = yup
  .object()
  .shape({
    sName: yup.string().required("Name is Required"),
    sFatherName: yup.string().required("Father Name is Required"),
    sAddress: yup.string().required("Address is Required"),
    sCNIC: yup.number().required("CNIC is Required"),
    sContact: yup.number().required("Phone is Required"),
    cName: yup.string().required("Customer Name is Required"),
    cFatherName: yup.string().required("Father Name is Required"),
    cAddress: yup.string().required("Address is Required"),
    cCNIC: yup.number().required("CNIC is Required"),
    cContact: yup.number().required("Phone is Required"),
    vChesis: yup.string().required("Chesis Number is Required"),
    vRegistration: yup.number().required("Registration No. is Required"),
    vAmountNumbers: yup.number().required("Total Amount is Required"),
    vModel: yup.number().required("Model is Required"),
    vEngine: yup.string().required("Engine Number is Required"),
    paymentDetails: yup.string().required("Required"),
  })
  .required();
